//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Container from "./Container";
import AppSponsors from "./AppSponsors";
import Row from "./Grid/Row";
import Column from "./Grid/Column";
import NavList from "../List/NavList/NavList";
import NavListHeader from "../List/NavList/NavListHeader";
import NavListItem from "../List/NavList/NavListItem";
import Divider from "../Divider/Divider";
import SocialIcons from "../Social/SocialIcons";
import AppFeatureButtons from "../Button/AppFeatureButtons";

export default {

    name: 'AppFooter',
    components: {SocialIcons, Divider, NavListItem, NavListHeader, NavList, Column, Row, AppSponsors, Container, AppFeatureButtons},
    props: {

        // Whether to show a search input to search for events, users, and clubs
        showSearch: {
            type: Boolean,
            default: false
        },

        // The navigation items to show
        items: {
            type: Array,
            default: null
        },

        withoutBottomPadding: {
            type: Boolean,
            default: false
        }
    }
}
